import {Pipe, PipeTransform} from '@angular/core';
import * as _ from 'lodash'
@Pipe({
    name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

    transform(array: Array<any>, fields?: any, olderFirst?: boolean): any {
       return _.orderBy(array, fields, olderFirst ? 'asc': 'desc');
    }

}
